module.exports = __webpack_public_path__ + "media/images/icons/discount-6c2bccd2a58681b01e5ff81a8ea9cc52.svg";